import React, { useEffect, useRef, useState } from 'react';
import { loadGoogleMaps } from '../utils/loadGoogleMaps';

export default function PublicServiceAreaMap({ center, radiusKm }) {
  const container = useRef(null);
  const [error, setError] = useState('');
  const lat = center?.lat;
  const lng = center?.lng;
  const valid = Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && !(lat === 0 && lng === 0) && Number.isFinite(radiusKm) && radiusKm > 0;

  useEffect(() => {
    if (!valid) return undefined;
    let cancelled = false;
    let circle;
    setError('');
    const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (!key) {
      setError('Coverage map is currently unavailable.');
      return undefined;
    }
    loadGoogleMaps(key).then((maps) => {
      if (cancelled || !container.current) return;
      const map = new maps.Map(container.current, {
        center: { lat, lng }, zoom: 11, mapTypeControl: false,
        streetViewControl: false, fullscreenControl: true, gestureHandling: 'cooperative',
      });
      circle = new maps.Circle({
        map, center: { lat, lng }, radius: radiusKm * 1000,
        strokeColor: '#209668', strokeOpacity: 0.9, strokeWeight: 2,
        fillColor: '#209668', fillOpacity: 0.18,
      });
      map.fitBounds(circle.getBounds(), 24);
    }).catch(() => { if (!cancelled) setError('Coverage map is currently unavailable.'); });
    return () => { cancelled = true; if (circle) circle.setMap(null); };
  }, [lat, lng, radiusKm, valid]);

  if (!valid || error) return <p className="mb-0 mt-4 rounded-xl bg-slate-50 p-4 text-sm text-slate-500">{error || 'Coverage map is not available for this Gigger yet.'}</p>;
  return <div className="mt-4"><div ref={container} role="region" aria-label={'Service coverage map: ' + radiusKm + ' km radius'} className="h-80 w-full overflow-hidden rounded-xl border border-slate-200 bg-slate-50" /><p className="mb-0 mt-2 text-xs leading-5 text-slate-500">The shaded area shows this Gigger’s service radius.</p></div>;
}
